class estadistics_1 {
    constructor(
        presents,
        ausents,
        inconsistencies,
        falls,
        lates,
        retreatBefore,
        daysLicense,
        hoursLicense,
        additionals,
        employeeWorkedHours,
        addHoursWorked
    ) {
        this.presents = presents || 3
        this.ausents = ausents || 3
        this.inconsistencies = inconsistencies || 3
        this.falls = falls || 3
        this.lates = lates || 3
        this.retreatBefore = retreatBefore || 3
        this.daysLicense = daysLicense || 3
        this.hoursLicense = hoursLicense || 3
        this.additionals = additionals || 3
        this.employeeWorkedHours = employeeWorkedHours || 3
        this.addHoursWorked = addHoursWorked || 3
    }



    static fromJson({
        StPresen,
        StAusen,
        StIncon,
        StCaidas,
        StTarde,
        StRetAnt,
        StLicDias,
        StLicHoras,
        StExtras,
        HorLabSum,
        HorTrabSum }) {
        return new estadistics_1(
            StPresen,
            StAusen,
            StIncon,
            StCaidas,
            StTarde,
            StRetAnt,
            StLicDias,
            StLicHoras,
            StExtras,
            HorLabSum,
            HorTrabSum
        )
    }
}
export default estadistics_1
